import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  ButtonGroup,
  FormGroup,
  Input,
  Label,
  FormFeedback,
  CardText,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "components/VerticalLayout/Footer";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";

const ViewTicket = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("1");

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const validationSchema = Yup.object({
    subject: Yup.string().required("Subject is required"),
    category: Yup.string().required("Category is required"),
    description: Yup.string().required("Description is required"),
    priority: Yup.string().required("Priority is required"),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      subject: "",
      category: "",
      description: "",
      priority: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      // Handle form submission
      // console.log("Form values:", values);

      //   try {
      //     const ticketData = {
      //       ticket: {
      //         currency: values.currency,
      //       },
      //     };
      //     const response = await post(api.CREATE_TICKET, ticketData);
      //     if (response && response.success) {
      //       showSuccessToast("Form submitted successfully!");
      //       navigate("/tickets");
      //     } else {
      //       showErrorToast(response.message || "Something went wrong.");
      //     }
      //   } catch (error) {
      //     showErrorToast(error);
      //   } finally {
      //   }
    },
  });

  const chatData = [
    {
      id: 1,
      sender: "User",
      message: "Hi, I need help with my account.",
      time: "10:00 AM",
    },
    {
      id: 2,
      sender: "Support",
      message: "Sure! What seems to be the issue?",
      time: "10:02 AM",
    },
    {
      id: 3,
      sender: "User",
      message: "I am unable to login to my account.",
      time: "10:05 AM",
    },
    {
      id: 4,
      sender: "Support",
      message: "Let me check that for you. Can you share your email ID?",
      time: "10:07 AM",
    },
  ];

  return (
    <div className="page-content">
      <Container fluid={true} className="py-0 px-0">
        {id ? (
          <PageSubHeader
          heading= {id ? `View Ticket ?? | ${id}` : 'View Ticket'}
            routePath={"Home"}
            pageName={"View Ticket"}
          />
        ) : (
          <PageSubHeader
            heading= {id ? `View Ticket ?? ${id}` : 'View Ticket'}
            routePath={"Home"}
            pageName={"View Ticket"}
          />
        )}

        <Row className="px-4 mx-0 my-3 ">
          <Col className="p-0 m-0" xs={12} md={12}>
            <Card>
              <CardBody>
                <Row className="card-group">
                  <Col xs={12} className="card-header">
                    <p className="form-header">Ticket Information</p>
                  </Col>
                  <Row className="card-group-body">
                    <ButtonGroup style={{ width: "50%" }}>
                      <Button
                        style={{
                          backgroundColor:
                            activeTab === "1"
                              ? "rgba(39, 174, 96, 0.5)"
                              : "#ffffff00",
                          borderBottom:
                            activeTab === "1"
                              ? "2px solid rgba(39, 174, 96, 1)"
                              : "none",
                          fontWeight: activeTab === "1" ? "500" : "normal",
                        }}
                        onClick={() => handleTabChange("1")}
                      >
                        Overview
                      </Button>
                      <Button
                        style={{
                          backgroundColor:
                            activeTab === "2"
                              ? "rgba(39, 174, 96, 0.5)"
                              : "#ffffff00",
                          borderBottom:
                            activeTab === "2"
                              ? "2px solid rgba(39, 174, 96, 1)"
                              : "none",
                          fontWeight: activeTab === "2" ? "500" : "normal",
                        }}
                        onClick={() => handleTabChange("2")}
                      >
                        Conversation
                      </Button>
                    </ButtonGroup>
                  </Row>

                  {activeTab === "1" && (
                    <>
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-3">
                          <Label htmlFor="subject">
                            Subject
                            <span className="text-danger"> *</span>
                          </Label>
                          <Input
                            name="subject"
                            type="text"
                            className="form-control"
                            id="subject"
                            value={formik.values.subject || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.subject && formik.errors.subject
                                ? true
                                : false
                            }
                            disabled
                          ></Input>
                          {formik.touched.subject && formik.errors.subject ? (
                            <FormFeedback type="invalid">
                              {formik.errors.subject}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-3">
                          <Label htmlFor="submittedBy">
                            Submitted By
                            <span className="text-danger"> *</span>
                          </Label>
                          <Input
                            name="submittedBy"
                            type="text"
                            className="form-control"
                            id="submittedBy"
                            value={formik.values.submittedBy || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.submittedBy &&
                              formik.errors.submittedBy
                                ? true
                                : false
                            }
                            disabled
                          ></Input>
                          {formik.touched.submittedBy &&
                          formik.errors.submittedBy ? (
                            <FormFeedback type="invalid">
                              {formik.errors.submittedBy}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col xs={12} md={6}>
                        <FormGroup className="mb-3">
                          <Label htmlFor="dateCreated">
                            Date Created
                            <span className="text-danger"> *</span>
                          </Label>
                          <Input
                            name="dateCreated"
                            type="date"
                            className="form-control"
                            id="dateCreated"
                            value={formik.values.dateCreated || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.dateCreated &&
                              formik.errors.dateCreated
                                ? true
                                : false
                            }
                            disabled
                          ></Input>
                          {formik.touched.dateCreated &&
                          formik.errors.dateCreated ? (
                            <FormFeedback type="invalid">
                              {formik.errors.dateCreated}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col xs={12} md={6}>
                        <FormGroup className="mb-3">
                          <Label htmlFor="priority">
                            Priority
                            <span className="text-danger"> *</span>
                          </Label>
                          <Input
                            name="priority"
                            type="text"
                            className="form-control"
                            id="priority"
                            value={formik.values.priority || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.priority && formik.errors.priority
                                ? true
                                : false
                            }
                            disabled
                          ></Input>
                          {formik.touched.priority && formik.errors.priority ? (
                            <FormFeedback type="invalid">
                              {formik.errors.priority}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-3">
                          <Label htmlFor="status">
                            Status
                            <span className="text-danger"> *</span>
                          </Label>
                          <Input
                            name="status"
                            type="text"
                            className="form-control"
                            id="status"
                            value={formik.values.status || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.status && formik.errors.status
                                ? true
                                : false
                            }
                            disabled
                          ></Input>
                          {formik.touched.status && formik.errors.status ? (
                            <FormFeedback type="invalid">
                              {formik.errors.status}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col xs={12} md={6}>
                        <FormGroup className="mb-3">
                          <Label htmlFor="category">
                            Category
                            <span className="text-danger"> *</span>
                          </Label>
                          <Input
                            name="category"
                            type="text"
                            className="form-control"
                            id="category"
                            value={formik.values.category || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.category && formik.errors.category
                                ? true
                                : false
                            }
                            disabled
                          ></Input>
                          {formik.touched.category && formik.errors.category ? (
                            <FormFeedback type="invalid">
                              {formik.errors.category}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="description">
                            Description <span className="text-danger"> *</span>
                          </Label>
                          <Input
                            name="description"
                            type="textarea"
                            className="form-control"
                            id="description"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.description &&
                              formik.errors.description
                                ? true
                                : false
                            }
                            value={formik.values.description || ""}
                            disabled
                          />
                          {formik.touched.description &&
                          formik.errors.description ? (
                            <FormFeedback type="invalid">
                              {formik.errors.description}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </>
                  )}
                  {activeTab === "2" && (
                    <>
                      <Col md="10">
                        <Card>
                          <CardBody>
                            <h5>Chat Conversation</h5>
                            <div className="chat-box" >
                              {chatData.map((chat) => (
                                <Row
                                  key={chat.id}
                                  className={`chat-message ${
                                    chat.sender === "User"
                                      ? "justify-content-start"
                                      : "justify-content-start"
                                  }`}
                                >
                                  <Col xs="8">
                                    <Card
                                      className={
                                        chat.sender === "User"
                                          ? "bg-light text-right"
                                          : "bg-white"
                                      }
                                      style={{marginBottom : "10px"}}
                                    >
                                      <CardBody style={{ paddingLeft: "10px" }}>
                                        <CardText className="d-flex align-items-center justify-content-start mb-2">
                                          <i
                                            class= {chat.sender !== "User" ? "fa fa-user" : "fa-regular fa-user" }
                                            style={{ fontSize: "13px" }}
                                          ></i>{" "}
                                          &nbsp;&nbsp;&nbsp;
                                          <strong
                                            style={{
                                              color: "rgb(39, 174, 96)",
                                            }}
                                          >
                                            {chat.sender}
                                          </strong>
                                          <span
                                            className="mx-2"
                                            style={{
                                              fontWeight: "bold",
                                              color: "black",
                                            }}
                                          >
                                            •
                                          </span>
                                          <small className="text-muted">
                                            {chat.time}
                                          </small>
                                        </CardText>
                                        <div>
                                          <strong>{chat.message}</strong>
                                        </div>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                </Row>
                              ))}
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                      <div
                        className="d-flex justify-content-evenly align-items-center mb-3 mx-auto my-3"
                        style={{ height: "100%" }}
                      >
                        <Col md="10">
                          <FormGroup className="mb-3">
                            <Label htmlFor="chatMessage">
                              Chat Message{" "}
                              <span className="text-danger"> *</span>
                            </Label>
                            <Input
                              name="chatMessage"
                              type="text"
                              className="form-control"
                              id="chatMessage"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.chatMessage &&
                                formik.errors.chatMessage
                                  ? true
                                  : false
                              }
                              // style={{ height: "0px" }}
                              value={formik.values.chatMessage || ""}
                            />
                            {formik.touched.chatMessage &&
                            formik.errors.chatMessage ? (
                              <FormFeedback type="invalid">
                                {formik.errors.chatMessage}
                              </FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="1" className="d-flex align-items-end">
                          <Button
                            type="submit"
                            color="primary"
                            className="w-100"
                            disabled={
                              formik.isSubmitting || !formik.values.chatMessage
                            }
                            style={{marginTop:"7px"}}
                          >
                            Send
                          </Button>
                        </Col>
                      </div>
                    </>
                  )}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {/* {activeTab !== "1" && (
        <Footer
          saveText="Create Ticket"
          save={() => navigate(`/add-ticket/${id}`)}
          showBackConfirmation={false}
        />
      )} */}
    </div>
  );
};

export default ViewTicket;
